import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import MovieCard from './MovieCard';
import Loader from './Loader';

const MovieRow = ({ title, movies = [], loading = false, accent }) => {
  const rowRef = useRef();

  const scroll = (dir) => {
    if (!rowRef.current) return;
    rowRef.current.scrollBy({ left: dir * 480, behavior: 'smooth' });
  };

  return (
    <section className="mb-10 md:mb-14">
      {/* Header */}
      <div className="flex items-center justify-between px-6 md:px-12 mb-5">
        <div className="flex items-center gap-3">
          {accent && (
            <div className="w-1 h-6 rounded-full" style={{ background: accent || 'var(--red)' }} />
          )}
          <h2 className="font-display text-2xl md:text-3xl tracking-wide" style={{ color: 'var(--text)' }}>
            {title}
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => scroll(-1)}
            className="w-9 h-9 rounded-full glass flex items-center justify-center hover:bg-white/10 transition-colors"
            style={{ color: 'var(--text)' }}
          >
            <FiChevronLeft size={18} />
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => scroll(1)}
            className="w-9 h-9 rounded-full glass flex items-center justify-center hover:bg-white/10 transition-colors"
            style={{ color: 'var(--text)' }}
          >
            <FiChevronRight size={18} />
          </motion.button>
        </div>
      </div>

      {/* Scroll Container */}
      <div className="relative">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-12 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to right, var(--dark), transparent)' }} />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-12 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to left, var(--dark), transparent)' }} />

        {loading ? (
          <Loader />
        ) : (
          <div
            ref={rowRef}
            className="flex gap-4 overflow-x-auto hide-scrollbar px-6 md:px-12 pb-4"
          >
            {movies.map((movie, i) => (
              <motion.div
                key={movie.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.04, duration: 0.4 }}
              >
                <MovieCard movie={movie} />
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default MovieRow;
